export const SEARCH_DEBOUNCE_MS = 200;
export const MIN_QUERY_LENGTH = 2;
export const INITIAL_GAMES_COUNT = 5;
export const INITIAL_PUBLISHERS_COUNT = 1;
export const MAX_GAMES_RESULTS = 30;
export const MAX_PUBLISHERS_RESULTS = 20;
